import { render, staticRenderFns } from "./Propietario.vue?vue&type=template&id=36dd45fc&scoped=true&"
import script from "./Propietario.vue?vue&type=script&lang=js&"
export * from "./Propietario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dd45fc",
  null
  
)

export default component.exports